export default {
  data() {
    return {
      link:$('#app-wrapper').attr('link'),
      is_editable_works: ($('#app-wrapper').attr('is_editable_works')==1),//юзер-владелец может добавлять/редактировать
      is_editor: ($('#app-wrapper').attr('is_editor')==1),//наш редактор/модератор
    }
  },

  methods : {
    is_show_collections(){
      if ( window._GL_works_collections==='n' ) return false;
      return true;
    },

    is_show_add_work(){
      if ( window._GL_works_show_add==='n' ) return false;
      return true;
    },
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/ArtistWorksMix.js
// module id = null
// module chunks = 